<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Parts Management' }}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-parts-management-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Parts Management</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-search class="search-bar" [partsManagementSearchTextForm]="filterFormGroup.controls.partsManagementSearchTextForm"></app-search>
    </div>
  </div>
  <app-parts-management-filters
    [filterFormGroup]="filterFormGroup"
    [isPartsManagementList]="isPartsManagementList"></app-parts-management-filters>
  <app-parts-management-grid
    [filterFormGroup]="filterFormGroup"
    class="table-container"
    [isPartsManagementList]="isPartsManagementList"></app-parts-management-grid>
</form>
